var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNatindaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 16,
    viewBox: "0 0 142 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1221_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.554 16.0001H11.0086L1.17832 1.40199V16.0037H0V0.0146484H1.61881L11.3757 14.5872V0.0146484H12.554V16.0001Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2473 15.9997H35.834L33.8628 10.8618H25.9303C25.6477 11.6702 25.3357 12.5223 25.0016 13.4253C24.6676 14.3247 24.3482 15.1841 24.0435 16.0034H22.7918C23.3204 14.6197 23.8453 13.2687 24.3592 11.9433C24.8731 10.6178 25.387 9.30333 25.8973 7.99245C26.4075 6.68157 26.9214 5.36705 27.4353 4.04161C27.9492 2.71617 28.4742 1.36887 29.0027 -0.00390625H30.6656L37.2436 15.9961L37.2473 15.9997ZM33.5251 9.94056L29.7883 1.04844L26.2423 9.94056H33.5288H33.5251Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8629 1.18352H54.2246V16.0037H53.0462V1.18352H47.4667V0.0146484H59.8592V1.18352H59.8629Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2386 16.0001H70.0603V0.0146484H71.2386V16.0001Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0561 16.0001H92.5107L82.6767 1.40199V16.0037H81.4984V0.0146484H83.1172L92.8741 14.5872V0.0146484H94.0524V16.0001H94.0561Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31 7.88364C117.31 13.2947 114.598 16.0002 109.172 16.0002H104.301V0.0292969H109.172C111.892 0.0292969 113.926 0.677453 115.28 1.97741C116.635 3.27736 117.31 5.24368 117.31 7.88364ZM116.059 7.88364C116.059 6.8313 115.952 5.89548 115.743 5.06526C115.534 4.23867 115.163 3.5359 114.631 2.95693C114.102 2.37795 113.39 1.93735 112.505 1.63512C111.617 1.33289 110.497 1.1836 109.143 1.1836H105.48V14.8349H109.143C110.486 14.8349 111.602 14.6784 112.491 14.3688C113.379 14.0593 114.087 13.6042 114.616 13.0034C115.145 12.4025 115.519 11.6779 115.736 10.8222C115.952 9.96648 116.059 8.98697 116.059 7.88728V7.88364Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 15.9997H140.587L138.616 10.8618H130.683C130.4 11.6702 130.088 12.5223 129.754 13.4253C129.42 14.3247 129.101 15.1841 128.796 16.0034H127.544C128.073 14.6197 128.598 13.2687 129.112 11.9433C129.626 10.6178 130.14 9.30333 130.65 7.99245C131.16 6.68157 131.674 5.36705 132.188 4.04161C132.702 2.71617 133.227 1.36887 133.755 -0.00390625H135.418L141.996 15.9961L142 15.9997ZM138.278 9.94056L134.541 1.04844L130.995 9.94056H138.281H138.278Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1221_3002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatindaLogo);
export default __webpack_public_path__ + "static/media/Natinda_Logo.90c668c09ffdc39cec104ff0959759d3.svg";
export { ForwardRef as ReactComponent };